import { FC, useEffect, useState } from 'react';

import styled from 'styled-components';
import Input from 'antd/es/input';

import { useBreakpoint } from '@contexts/breakpoints';
import CustomIcon from '@components/utils/CustomIcon';
import { Calendar2Line } from '@assets/icons';
import { FlexibleDiv } from '@components/formStyles';
import { SearchBarInputStyles } from '@shared/searchBar/styled';

type PropTypes = {
  value: string;
  label: string;
  isOneWay?: boolean;
  rightBorder?: boolean;
  onClick?(): void;
};

const StyledInput = styled(Input)`
  &&& {
    width: 100%;
    height: 56px;
    border-radius: 4px;
    ${SearchBarInputStyles};

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
    }
  }
`;

const SelectedComp: FC<PropTypes> = ({ value, label }) => {
  const { xl } = useBreakpoint();

  const [val, setVal] = useState('');

  useEffect(() => {
    if (value) {
      setVal(value);
    } else {
      setVal('');
    }
  }, [value]);

  return (
    <StyledInput
      className='date-input-component'
      readOnly
      placeholder={label}
      value={val}
      prefix={
        <FlexibleDiv right={4}>
          <CustomIcon
            fontSize={xl || xl === undefined ? 24 : 18}
            icon={Calendar2Line}
            paletteColor='grey500'
          />
        </FlexibleDiv>
      }
    />
  );
};

export default SelectedComp;
